<template>
  <v-dialog scrollable v-model="config.status.active" max-width="600">
    <v-card>
      <v-card-text>
        <v-container grid-list-md :class="{ 'px-0': $vuetify.breakpoint.xs }">
          <v-form lazy-validation ref="form" v-model="form.valid">
            <ArrangementsForm ref="inputers" />
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat class="blue--text text--darken-2" @click="close">閉じる</v-btn>
        <v-btn depressed color="blue darken-2 white--text" @click="submit">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ArrangementsForm from '../../forms/arrangements'
export default {
  name: 'arrangementsModal',
  components: {
    ArrangementsForm
  },
  data () {
    return {
      config: {
        status: {
          active: false
        }
      },
      meta: {
      },
      form: {
        valid: true
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$emit('done', {
          type: 'arrangements',
          data: this.$refs.inputers.getForm()
        })
        this.close()
      }
    },
    open: function (values) {
      this.$set(this.config.status, 'active', true)
      this.$set(this.form, 'valid', true)
      this.$nextTick(() => {
        this.$refs.inputers.init({ values })
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
  }
}
</script>
